export default "__VITE_ASSET__7aa09738__"